<script>
export default {
	data() {
		return {
			isRunning: true,
			allowVerify: false,
			isCorrect: false,
			selectedIndex: 0,
			selectedValue: 0,

			answer: [],
			correct: [],
			correctRange: [],
			incorrect: [],
		};
	},
	methods: {
		onVerify() {
			if (!this.allowVerify) { return; }

			// Logging
			this.$log.onInputVerify(this.answer, this.correct, this.isCorrect);

			if (this.isCorrect) {
				this.isRunning = false;
				this.$emit('complete');
			}
			else {
				this.allowVerify = false;
				this.$tracker.onTaskMistake();

				for (let i in this.answer) {
					let answer = this.answer[i];
					if (typeof this.correct[i] == "number") {
						answer = this.toNumber(answer)
					}

					if (this.correctRange[i][0] <= answer && answer <= this.correctRange[i][1]) {
						this.incorrect[i] = null;
					}
					else {
						this.incorrect[i] = answer;
					}
				}
			}
		},
		isValidNumber(value) {
			if (typeof value == "number") return true;
			if (typeof value != "string") return false;
			if (value.length == 0) return true;
			value = value.replace(",", ".");
			return !isNaN(value) && !isNaN(parseFloat(value));
		},
		toNumber(value) {
			if (typeof value == "number") return value;
			if (value === "") {
				return 0;
			}
			if (this.isValidNumber(value)) {
				return parseFloat(value.replace(",", "."));
			}
			return NaN;
		}
	},
	computed: {},
	watch: {
		answer() {
			this.$log.onInputChange(this.answer);

			this.allowVerify = this.answer.every((value,index) => {
				if (typeof this.correct[index] == "number" && !this.isValidNumber(value))
					return false;
				return (value !== '') && (value != this.incorrect[index]);
			});
			this.isCorrect = this.answer.every((value,index) => {
				if (typeof this.correct[index] == "number")
					value = this.toNumber(value);
				return (this.correctRange[index][0] <= value && value <= this.correctRange[index][1]);
			});

			this.answer.forEach((answer, index) => {
				if (answer != this.incorrect[index]) {
					this.incorrect[index] = null;
				}
			});
		}
	},
	created() {},
	mounted() {},
	updated() {},
	unmounted() {},
};
</script>
